import React from "react";
import { AlertTriangle } from "lucide-react";
import { SOPDetailsCard } from "./SOPDetailsCard";
import { EntitySelectionSection } from "./EntitySelectionSection";
import { PriorityNotesSection } from "./PriorityNotesSection";
import { AvailableTechniciansCard } from "./AvailableTechniciansCard";
import { SOPTemplate } from "@features/wx/dispatcher/types";
interface MainContentPanelProps {
  selectedSOP: SOPTemplate | null;
  selectedEntities: any[];
  onEntitiesChange: (entities: any[]) => void;
  priority: string;
  onPriorityChange: (priority: string) => void;
  notes: string;
  onNotesChange: (notes: string) => void;
  onTechnicianSelect?: (technician: any) => void;
}
export const MainContentPanel: React.FC<MainContentPanelProps> = ({
  selectedSOP,
  selectedEntities,
  onEntitiesChange,
  priority,
  onPriorityChange,
  notes,
  onNotesChange,
  onTechnicianSelect,
}) => {
  if (!selectedSOP) {
    return (
      <div className="flex-1 flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <AlertTriangle className="mx-auto h-12 w-12 text-gray-400 mb-4" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">
            Select an SOP Template
          </h3>
          <p className="text-gray-500">
            Choose a template from the left panel to get started
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex-1 overflow-y-auto p-6 space-y-6 bg-gray-50">
      {/* SOP Details Card */}
      <SOPDetailsCard sop={selectedSOP} />

      {/* Entity Selection Section */}
      <EntitySelectionSection
        serviceAssociation={selectedSOP.association}
        selectedEntities={selectedEntities}
        onEntitiesChange={onEntitiesChange}
      />

      {/* Available Technicians Card */}
      <AvailableTechniciansCard
        selectedSOP={selectedSOP}
        selectedEntities={selectedEntities}
        onTechnicianSelect={onTechnicianSelect}
      />

      {/* Priority & Notes Section */}
      <PriorityNotesSection
        priority={priority}
        onPriorityChange={onPriorityChange}
        notes={notes}
        onNotesChange={onNotesChange}
      />
    </div>
  );
};
